import type {Result, UseCase} from 'framework';
import type {AuthRepository} from '../ports/auth.repository';
import type {Session} from '../../domain/session';
import type {GetSessionError} from '../../domain/errors';

export class GetSession implements UseCase<[], Session | null> {
  constructor(private readonly authRepository: AuthRepository) {}

  execute(): Promise<Result<Session | null, GetSessionError>> {
    return this.authRepository.getSession();
  }
}
